/**
 * Native status bar styling (src/platform/). Keeps the bar legible against
 * the app theme. No-op on web.
 */

import { cssToken } from '@/lib/cssToken'
import { isNativePlatform } from './detection'

/** Sync the status bar with the active theme. */
export async function syncStatusBar(theme: 'light' | 'dark'): Promise<void> {
  if (!isNativePlatform()) return
  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar')
    // Style.Dark means light text, for dark backgrounds.
    await StatusBar.setStyle({ style: theme === 'dark' ? Style.Dark : Style.Light })
    await StatusBar.setBackgroundColor({ color: cssToken('--background') })
  } catch {
    // Plugin or platform capability unavailable (setBackgroundColor is Android-only).
  }
}
